<script lang="ts" setup>
useHead({
  title: "Privacy Policy",
});

definePageMeta({
  layout: "simplified",
});
</script>

<template>
  <UMain>
    <UPage>
      <UPageHeader
        title="Privacy Policy"
        description="Last updated: 21.02.2024" />

      <UPageBody prose>
        <div class="pb-8">
          This Privacy Policy outlines how Vimi Pussewala Hewage ("VimiCrypto",
          "we", "us", or "our") collects, uses, maintains, and discloses
          information collected from users (each, a "User") of our website
          vimicrypto.com ("Website").
        </div>

        <h1 class="text-2xl">Personal Identification Information</h1>
        <div class="pb-8">
          We may collect personal identification information from Users in
          various ways, including but not limited to when Users visit our
          Website, register on the Website, subscribe to our newsletter, respond
          to a survey, fill out a form, and in connection with other activities,
          services, features, or resources we make available on our Website.
          Users may be asked for, as appropriate, name, email address, and other
          relevant information.
          <br />
          <br />
          We collect personal identification information from Users only if they
          voluntarily submit such information to us. Users can always refuse to
          supply personal identification information, except that it may prevent
          them from engaging in certain Website-related activities.
        </div>

        <h1 class="text-2xl">Non-Personal Identification Information</h1>
        <div class="pb-8">
          We may collect non-personal identification information about Users
          whenever they interact with our Website. Non-personal identification
          information may include the browser name, the type of computer, and
          technical information about Users' means of connection to our Website,
          such as the operating system and the Internet service providers
          utilized, as well as other similar information.
        </div>

        <h1 class="text-2xl">Web Browser Cookies</h1>
        <div class="pb-8">
          Our Website may use "cookies" to enhance User experience. Users' web
          browsers place cookies on their hard drive for record-keeping purposes
          and sometimes to track information about them. Users may choose to set
          their web browser to refuse cookies or to alert you when cookies are
          being sent. If they do so, note that some parts of the Website may not
          function properly.
        </div>

        <h1 class="text-2xl">How We Use Collected Information</h1>
        <div class="pb-8">
          We may collect and use Users' personal information for the following
          purposes:
          <ul>
            <ol>
              To personalize user experience: We may use information in the
              aggregate to understand how our Users as a group use the services
              and resources provided on our Website.
            </ol>
            <ol>
              To send periodic emails: We may use the email address to send User
              information and updates pertaining to their order. It may also be
              used to respond to their inquiries, questions, and/or other
              requests. If User decides to opt-in to our mailing list, they will
              receive emails that may include company news, updates, related
              product or service information, etc.
            </ol>
          </ul>
        </div>

        <h1 class="text-2xl">How We Protect Your Information</h1>
        <div class="pb-8">
          We adopt appropriate data collection, storage, and processing
          practices and security measures to protect against unauthorized
          access, alteration, disclosure, or destruction of your personal
          information, username, password, transaction information, and data
          stored on our Website.
        </div>

        <h1 class="text-2xl">Sharing Your Personal Information</h1>
        <div class="pb-8">
          We do not sell, trade, or rent Users' personal identification
          information to others. We may share generic aggregated demographic
          information not linked to any personal identification information
          regarding visitors and users with our business partners, trusted
          affiliates, and advertisers for the purposes outlined above.
        </div>

        <h1 class="text-2xl">Changes to This Privacy Policy</h1>
        <div class="pb-8">
          VimiCrypto has the discretion to update this privacy policy at any
          time. When we do, we will revise the updated date at the top of this
          page. We encourage Users to frequently check this page for any changes
          to stay informed about how we are helping to protect the personal
          information we collect. You acknowledge and agree that it is your
          responsibility to review this privacy policy periodically and become
          aware of modifications.
        </div>

        <h1 class="text-2xl">Your Acceptance of These Terms</h1>
        <div class="pb-8">
          By using this Website, you signify your acceptance of this policy. If
          you do not agree to this policy, please do not use our Website. Your
          continued use of the Website following the posting of changes to this
          policy will be deemed your acceptance of those changes.
        </div>

        <h1 class="text-2xl">Contacting Us</h1>
        <div class="pb-8">
          If you have any questions about this Privacy Policy, the practices of
          this Website, or your dealings with this Website, please contact us at
          support@viminorge.com.
        </div>
      </UPageBody>
    </UPage>
  </UMain>
</template>

<style></style>
